import React from 'react'
import TextComponent from '../TextComponent';
import Label from '../Label';
import Tooltip from '../Tooltip';

import ico from 'images/products/wave_solder_pallets/hold-downs.png'

const HoldDownQuantity = (props) => {
  const onChange = e => props.onChangeParameter(props.name, e.target.value);
  const value = props.parameters[props.name];
  return (
    <div className="row g-0 mb-3">
      <div className="col-4 col-md-3 col-lg-4">
        <img src={ico} alt="Hold Down Quantity" className="img-fluid mb-3" />
      </div>
      <div className="col-8 col-md-9 col-lg-8 ps-3 ps-md-0 ps-lg-3">
        <div className="row g-0">
          <div className="col-7 col-md-12 col-lg-7">
            <Label label={props.label} required={props.required} > <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} /> </Label>
          </div>
          <div className="col-5 ps-2 ps-md-0 ps-lg-2">
            <TextComponent
              label={null}
              name={props.name}
              inputId={props.inputId}
              value={value || ''}
              required={props.required}
              onChange={onChange}
              tooltip={props.tooltip}
              min="1"
              wrapClass={false}>
            </TextComponent>
          </div>
        </div>
        <small>We recommend a minimum of two per board</small>
        {props.children}
      </div>
    </div>
  )
}

HoldDownQuantity.defaultProps = {
  inputId: 'hold_down_quantity',
  label: '# of Hold Downs ($2 each)',
  name: 'hold_down_board_quantity',
  required: true,
};

export default HoldDownQuantity;
